var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 95,
    viewBox: "0 0 60 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1833 72.1227L40.8236 79.8C44.676 81.9683 48.7882 77.3967 46.2255 73.7946L35.3014 58.4394C33.9247 56.5042 34.4556 53.8098 36.4635 52.5415L57.2049 39.4406C60.9017 37.1056 58.9225 31.3789 54.5729 31.8248L34.4519 33.8876C31.8263 34.1568 29.6231 31.9324 29.9173 29.3095L32.6091 5.3132C33.1213 0.747331 26.9231 -1.12815 24.818 2.95575L13.6996 24.5258C12.5098 26.8341 9.51266 27.4889 7.46857 25.8872L-10.9248 11.474C-14.3832 8.76405 -19.1242 12.5999 -17.1958 16.5478L-4.1441 43.268C-3.19984 45.2011 -3.89427 47.5353 -5.74166 48.6379L-29.6621 62.9147C-33.5393 65.2288 -31.4361 71.1952 -26.9648 70.5663L-0.152605 66.7953C2.30868 66.4492 4.51773 68.3354 4.56153 70.8205L4.9037 90.2375C4.98058 94.6002 10.8836 95.8893 12.7721 91.9558L21.4228 73.9379C22.4578 71.7821 25.0993 70.9498 27.1833 72.1227Z",
    fill: "#1B3B5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarLeft);
export default __webpack_public_path__ + "static/media/starLeft.d3a0833a1c8aeaf205f446af97220583.svg";
export { ForwardRef as ReactComponent };